var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmotionsAngry = function SvgEmotionsAngry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-angry_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.468 5.144a.833.833 0 0 0-.936 1.379l.946.643a1.667 1.667 0 1 0 2.83.877.833.833 0 0 0-.238-1.131zm1.195 9.64a.75.75 0 0 1-.277-1.024 4.166 4.166 0 0 1 7.227-.002.75.75 0 0 1-1.3.747 2.666 2.666 0 0 0-4.626.002.75.75 0 0 1-1.024.277m9.127-9.42a.833.833 0 0 0-1.157-.22l-2.601 1.768a.834.834 0 0 0-.31.99A1.668 1.668 0 0 0 13.334 10a1.667 1.667 0 0 0 1.229-2.793l1.008-.684a.833.833 0 0 0 .22-1.158",
    clipRule: "evenodd",
    opacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-angry_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 2.708 7.292)scale(15.4167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#f26325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f24a25"
  })))));
};
export default SvgEmotionsAngry;